import {
	Typography,
} from '@apostrophe/ui';
import styled from 'styled-components';
import {
	media,variables
} from 'styledComponents/utils';

const Spacer = styled.div`
  height: 10px;
  width: 100%;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  
  &.desk-submit-button {
    display: none;

    @media (min-width: 1024px) {
      display: flex;
    }
  }
`;

const Divider = styled.div`
  width: 100%;
  text-align: center;
  border-bottom: 1px solid rgb(216,216,216);
  line-height: 0.1em;
  margin: 30px 0 30px;

  span {
    background: ${props => props.darkMode ? 'white': '#FFFEFA'};
    color: #8B8A87;
    font-size: 1.25rem;
    padding: 0 20px;
    ${props => props.medCheckout && 'background-color: white; font-size: 13px;'}
  }
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;

  ${props => props.medCheckout && 'margin-top: 0;'}
  ${props => props.isPrepay && 'margin-top: 0; h2 { margin-top: 0; }'}
	${props => props.useUpdatedRegistration && 'margin-top: 32px;'}

  h2 {
    margin-top: unset;
  }
  a {
    font-size: .75rem;
    border-bottom: 1px solid ${variables.midGrey};
    color: ${variables.midGrey};

    &:hover {
      color: ${variables.darkGrey};
      border-bottom: 1px solid ${variables.darkGrey};
      cursor: hover;
    }
  }
  transition: all .03s ease;
`

const FinePrint = styled.div`
  margin-top: 20px;
  font-size: 10px;
`

const NewCheckoutWrapper = styled.div`
  ${props => props.isPrepay && 'margin-top: 0; h2 { margin-top: 0; }'}

  .GooglePayButton-logo {
    ${props => props.medCheckout && 'border: 1px solid #d9d9d9; borderRadius: 2px; margin-top: 10px; max-height: 295px;'}
  }
`;

const OrderConfirmationWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
  padding-top: 0;
  background-color: white;
  padding-bottom: 0;
  box-shadow: 0 2px 4px rgba(51, 51, 51, 0.08);
`;

const CartWrapper = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
`;

const BlurbWrapper = styled.div`
  background-color: rgba(255, 249, 128, 0.3);
  padding: 20px;
  height: auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
`;

const DoctorImg = styled.div`
  height: 60px;
  width: 60px;
  min-width: 60px;
  margin-right: 30px;
  border-radius: 30px;
  background-image: url(${props => props.doctorUrl});
  background-size: cover;
  background-repeat: no-repeat;
`;

const Blurb = styled.div`
  font-size: 14px;
  color: #8B8A87;
`;

const ErrorState = styled.div`
  font-size: 12px;
  color: rgb(200, 72, 61);
  margin-bottom: 14px;
`;

const CartItem = styled.div`
  display: flex;
  height: auto;
  padding: 20px 0px;
  border-bottom: 1px solid #d9d9d9;
  justify-content: space-between;
  .name {
    max-width: 210px;
    ${media.tablet`
      max-width: unset;
    `}
  }
  ${props => props.light && 'color: #8B8A87'}
  ${props => props.total && 'color: #000000; border: none; font-weight: 900;'}
`;


const UpdatedTitle = styled(Typography).attrs({ variant: 'subtitle2' })`
  margin-top: 0px;
  margin-bottom: 0px;
`

export {
	Blurb,
	BlurbWrapper,
	ButtonWrapper,
	CartItem,
	CartWrapper,
	Divider,
	DoctorImg,
	ErrorState,
	FinePrint,
	NewCheckoutWrapper,
	OrderConfirmationWrapper,
	Spacer,
	TitleContainer,
	UpdatedTitle,
}

